import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElIcons from '@element-plus/icons-vue'
import JsonExcel from 'vue-json-excel3'
// ‘downloadExcel’ 为 组册组件名字 

import Echarts from "vue-echarts"
import * as echarts from "echarts"

import vueEsign from 'vue-esign'


 

 



const app = createApp(App).use(router).use(store)

for (const [name, icon] of Object.entries(ElIcons)) { // 修改遍历方式
    app.component(name, icon)
  }

  
app.component('downloadExcel', JsonExcel)
app.component("v-chart", Echarts)
app.config.globalProperties.$echarts = echarts


app.use(vueEsign)
app.use(ElementPlus)
app.mount('#app')





// set NODE_OPTIONS=--max_old_space_size=8192